export enum Networks {
  CARS_LACROIX = 'CARS-LACROIX',
}
